import { MessageCircle, Shield, Truck } from "lucide-react";

/**
 * Trust badges component showing pickup convenience and authenticity guarantees
 * Enhanced with improved visual hierarchy and alignment consistency
 */
export function TrustBadges() {
  const badges = [
    {
      icon: Truck,
      text: "Convenient city centre pickup",
    },
    {
      icon: Shield,
      text: "Authentic guarantee",
    },
    {
      icon: MessageCircle,
      text: "Expert advice available",
    },
  ];

  return (
    <div className="space-y-4">
      <h3 className="font-medium text-base text-foreground">
        Why shop with us?
      </h3>
      <div className="space-y-4">
        {badges.map((badge) => (
          <div className="flex items-center gap-3" key={badge.text}>
            <div className="flex h-6 w-6 items-center justify-center">
              <badge.icon className="h-5 w-5 text-primary" strokeWidth={1.5} />
            </div>
            <p className="text-base text-muted-foreground">{badge.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
